if (!customElements.get("flixmedia-content")) {
  customElements.define(
    "flixmedia-content",
    class FlixmediaContent extends HTMLElement {
      connectedCallback() {
        this.loaded = false;
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.loadContent();
          }
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.contentObserver?.disconnect();
        clearTimeout(this.emptyTimeout);
      }

      loadContent() {
        if (this.loaded) return;
        this.loaded = true;
        this.observer?.disconnect();

        const container = this.querySelector("[data-flixmedia-container]");
        if (!container) return;

        this.watchForContent(container);

        const { distributor, lang, ean } = this.dataset;
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.crossOrigin = "anonymous";
        script.src = `https://media.flixcar.com/delivery/js/inpage/${distributor}/${lang}/ean/${ean}?ssl=1&ext=.js`;
        container.append(script);
      }

      watchForContent(container) {
        const hasRealContent = () =>
          Array.from(container.children).some((node) => node.tagName !== "SCRIPT");

        this.contentObserver = new MutationObserver(() => {
          if (hasRealContent()) {
            this.contentObserver.disconnect();
            clearTimeout(this.emptyTimeout);
          }
        });
        this.contentObserver.observe(container, { childList: true });

        this.emptyTimeout = setTimeout(() => {
          this.contentObserver?.disconnect();
          if (!hasRealContent()) {
            document.getElementById(`flixmedia-content-${this.dataset.sectionId}`)?.remove();
          }
        }, 5000);
      }
    }
  );
}
